import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { Props as BaseEntityLinkProps } from "~/components/base-entity-link";
import { HeaderAllMenuItemLink } from "~/components/header/header-oneline-menu-container/header-all-menu/common";
import { useOnelineMenuTracking } from "~/components/header/header-oneline-menu-container/hooks";
import { sendGATracking } from "~/components/tracking/google-analytics/apis";
import type { headerAllMenuHighlightsQuery$key } from "~/queries/__generated__/headerAllMenuHighlightsQuery.graphql";

import { Container, LinkContainer, Title } from "./styles";

export type Props = {
  className?: string;
  queryParameter: BaseEntityLinkProps["query"];
  reference: headerAllMenuHighlightsQuery$key;
};

export const HeaderAllMenuHighlights: FunctionComponent<Props> = ({
  className,
  queryParameter,
  reference: reference_,
}) => {
  const { edition } = useOnelineMenuTracking();
  const queue = useFragment(
    graphql`
      fragment headerAllMenuHighlightsQuery on Query {
        highlightsQueue: queue(filter: { name: "all_menu_highlights" }) {
          items(first: 4) {
            edges {
              node {
                ... on Topic {
                  ...entityLink
                  name
                }
                ... on Section {
                  ...entityLink
                  name
                }
              }
            }
          }
        }
      }
    `,
    reference_,
  );

  return (
    <Container className={className}>
      <Title>Highlights</Title>
      <LinkContainer>
        {queue.highlightsQueue?.items?.edges.map((edge, index) => (
          <HeaderAllMenuItemLink
            key={index}
            query={queryParameter}
            reference={edge.node}
            onClick={() => {
              sendGATracking({
                action: "Linemenu/Click",
                category: "Menu",
                label: `${edition}/Linemenu/All/Highlights/${edge.node.name ?? ""}`,
              });
            }}
          >
            {edge.node.name}
          </HeaderAllMenuItemLink>
        ))}
      </LinkContainer>
    </Container>
  );
};

HeaderAllMenuHighlights.displayName = "HeaderAllMenuHighlights";
